var _rect, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTenisSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F0F0F0",
    rx: 11
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "6v44xl7uia",
    width: 24,
    height: 18,
    x: 8,
    y: 11,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8 11h23.165v17.848H8V11z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#6v44xl7uia)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    fillRule: "evenodd",
    d: "M29.13 18.578c-1.125 0-2.037-.912-2.037-2.035 0-1.125.912-2.036 2.036-2.036 1.125 0 2.036.91 2.036 2.036 0 1.123-.91 2.035-2.036 2.035zm-14.55 4.595l-.905-.905.545-1.852c.253.497.583.96.993 1.37.345.345.727.633 1.135.867l-1.768.52zm9.807-10.56c-2.303-2.303-6.234-2.117-8.763.412-1.598 1.598-2.259 3.755-1.948 5.708-.05.055-.089.122-.11.197l-.906 3.078-4.209 4.21c-.6.6-.6 1.579 0 2.18.601.6 1.578.6 2.18 0l4.21-4.21 3.077-.904.04-.017c2.031.434 4.334-.209 6.018-1.892 2.53-2.529 2.714-6.46.411-8.761z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenisSmall);
export default __webpack_public_path__ + "static/media/tenis_small.043704b174efb2edf01c3a3f99ff4a5d.svg";
export { ForwardRef as ReactComponent };